module.exports = __webpack_public_path__ + "img/8.80f18d40.webp";